import { useEffect as u } from "react";
const c = (e, n) => {
  u(
    () => {
      const t = (o) => {
        !e.current || e.current.contains(o.target) || n(o);
      };
      return document.addEventListener("mousedown", t), document.addEventListener("touchstart", t), () => {
        document.removeEventListener("mousedown", t), document.removeEventListener("touchstart", t);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [e, n]
  );
}, d = (e, n) => {
  u(
    () => {
      const t = (o) => {
        e.some((r) => !r.current || r.current.contains(o.target)) || n(o);
      };
      return document.addEventListener("mousedown", t), document.addEventListener("touchstart", t), () => {
        document.removeEventListener("mousedown", t), document.removeEventListener("touchstart", t);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [e, n]
  );
};
export {
  c as useOnClickOutside,
  d as useOnClickOutsideMultiple
};
